<template>
  <div>
    <div class="form-group">
      <input v-enter-to-tab type="checkbox" :disabled="disabled" :id="labelId" :checked="checked"
             :class="`EnterToTab ${disabled && !checked ? 'unselected-check-disabled' : ''}`"
             @click="$emit('click', $event)"
      />
      <label :for="labelId">{{ label }}</label>
    </div>
  </div>
</template>

<script>
import randomStringGenerator from '@/utils/randomStringGenerator';

export default {
  name: 'CheckBox',
  props: {
    label: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: ()  => {
    return {
      labelId: '',
    }
  },
  created() {
    this.labelId = randomStringGenerator(5);
  }
}
</script>

<style scoped>

.form-group {
  margin-bottom: 0px;
}

label {
  margin-bottom: 0;
}

input[type="checkbox"] {
  content:'';

  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
  width: 14px;
  height: 14px;
}

input[type="checkbox"]:checked {
  border: solid white;
  border-width: 0 2px 2px 0;

  accent-color: #4f23c9;
}

input[disabled] {
  border-color: #ababb5;
  background-color: #ababb5;
}

.unselected-check-disabled {
  background-color: transparent !important;
}

</style>
